const mediaController = () => {

    mediaDurationHandler();
    $(document).on('click', '.js-media-button-play', function(){

        const parent      = $(this).parents('.js-media-controller');
        const playerID    = parent.find('audio').attr('id');
        const player      = document.getElementById(playerID);
        const play        = parent.find('.js-media-button-play');
        const pause       = parent.find('.js-media-button-pause');
        const slider      = parent.find('#js-media-slider');
        const progressBar = parent.find('#js-media-progress');
        const time        = parent.find('#js-current-time');
        const mediaBlock  = parent.find('.js-media-control');
        const volumeBlock = parent.find('.js-media-controller-sound');
        const volumeON    = parent.find('.js-media-controller-sound-on');
        const volumeOFF   = parent.find('.js-media-controller-sound-off');
        const volumeBar   = parent.find('.js-media-controller-sound-level');
        const soundON     = 'media-controller__sound--enabled';
        const soundOFF    = 'media-controller__sound--disabled';
        const playClass   = '_playing';
        const pauseClass  = '_paused';
        const loadedClass = '_loaded';
        let duration      = 0;
        let volume        = 1;


        if ( !parent.hasClass(loadedClass) ) {

            parent.addClass(loadedClass);

            player.onloadedmetadata = function() {
                duration = player.duration;
                progressBar.progressbar('option', { 'max' : duration });
            };

            player.load();

            player.volume = 1;
            player.addEventListener('timeupdate', function() {
                progressBar.progressbar('value', player.currentTime);
                time.text(getTime(player.currentTime));
            }, false);

            volumeBar.progressbar({
                value: player.volume * 100
            });

            volumeBar.on('click', function(e) {
                let info = getProgressBarClickInfo($(this), e);

                volumeBar.progressbar('value', info.value);
                player.volume = info.value / info.max;
            });

            progressBar.progressbar({
                value: player.currentTime
            });

            progressBar.on('progressbarchange', function() {
                let position = parseInt($(this).find('.ui-progressbar-value').css('width')),
                    width    = $(this)[0].clientWidth - 8;

                if (position >= width) {
                    position = width;
                }

                slider.css({
                    'left': position
                });
            });

            progressBar.on('click', function(e) {
                let info = getProgressBarClickInfo($(this), e);

                player.currentTime = player.duration / info.max * info.value;
            });

            pause.on('click', function() {
                player[player.paused ? 'play' : 'pause']();
                mediaBlock.removeClass(playClass).addClass(pauseClass);
            });
            
            volumeOFF.on('click', function() {
                if (player.volume === 0) {
                    player.volume = volume;
                }
                else {
                    volume = player.volume;
                    player.volume = 0;
                }


                volumeBar.progressbar('value', player.volume * 100);
                volumeBlock.addClass(soundON).removeClass(soundOFF);
            });
            volumeON.on('click', function() {
                player.volume = volume;
                if (player.volume === 0) {
                    player.volume = volume;
                }
                else {
                    volume = player.volume;
                    player.volume = 0;
                }
                volumeBar.progressbar('value', player.volume * 100);
                volumeBlock.addClass(soundOFF).removeClass(soundON);
            });
        }

        player.play();
        mediaBlock.removeClass(pauseClass).addClass(playClass);
    });

    function getTime(t) {
        let m = ~~(t / 60), s = ~~(t % 60);
        return (m < 10 ? m : m) + ':' + (s < 10 ? "0" + s : s);
    }
    function getProgressBarClickInfo(progressBar, e) {
        let offset = progressBar.offset(),
            x = e.pageX - offset.left,
            y = e.pageY - offset.top,
            max = progressBar.progressbar('option', 'max'),
            value = x * max / progressBar.width();

        return { x: x, y: y, max: max, value: value };
    }
    function mediaDurationHandler() {
        $('.js-media-controller').each(function(){
            let duration    = 0;
            const playerID  = $(this).find('audio').attr('id');
            const player    = document.getElementById(playerID);
            const timer     = $(this).find('.media-controller__timer');

            if( player.readyState > 0 ) {
                const minutes  = parseInt(player.duration / 60, 10);
                const seconds  = parseInt(player.duration % 60);
                      duration = minutes+":"+seconds;

                timer.text(duration);
            }
        });
    }
}
